import React from 'react';

const About = () => (
  <>
    <h1>About This App</h1>
    <p>App to search GitHub Users</p>
    <p>Version: 1.0.0</p>
  </>
);

export default About;
